import { FAQSection } from 'components/shared/FAQSection';

const HomeFaqData = [
  {
    title: 'What is Ultrahuman Home?',
    description: (
      <>
        Ultrahuman Home is a smart health device designed to monitor and enhance
        the health of your living environment. It continuously tracks
        environmental factors such as air quality, temperature, humidity, light,
        noise, and more, correlating them with your lifestyle and biomarkers to
        optimize your health outcomes.
      </>
    ),
  },
  {
    title: 'What is Ultrahuman Home made from?',
    description: (
      <>
        Ultrahuman Home is built using high-grade, durable materials to ensure
        long-term reliability. The outer casing is crafted from sustainable,
        eco-conscious plastics and metals, while the internals include precision
        sensors and custom-designed circuit boards optimized for real-time
        environmental sensing.
      </>
    ),
  },
  {
    title: 'What is the expected lifespan of Ultrahuman Home?',
    description: (
      <>
        Ultrahuman Home is designed with industry-grade sensors and precision
        engineering. The product goes through rigorous quality checks to ensure
        longevity and consistent performance for over a decade. However,
        periodic cleaning of the vents is recommended to ensure the product
        lasts longer & works efficiently in your living space.
      </>
    ),
  },
  {
    title:
      'How can I use the data from Ultrahuman Home to improve my biomarkers?',
    description: (
      <>
        Ultrahuman Home correlates environmental data - such as CO₂ levels,
        PM2.5, temperature, and humidity - with health metrics like sleep
        quality and stress. The platform uses this information to suggest
        actionable changes (e.g., improving ventilation, optimizing temperature
        for sleep) that enhance your lifestyle and positively affect your
        biomarkers over time.
      </>
    ),
  },
  {
    title: `Is privacy a concern with Ultrahuman Home's microphone?`,
    description: (
      <>
        All audio processing for the device is conducted locally, ensuring your
        data remains secure. The Ultrahuman Home device also includes a physical
        mic cut-off button, giving you full control over your privacy.
      </>
    ),
  },
  {
    title: 'How do I use Ultrahuman Home?',
    description: (
      <>
        Using Ultrahuman Home is simple:
        <br />
        <ul>
          <li>Plug in the device and connect it to your home Wi-Fi.</li>

          <li>Use the Ultrahuman App to pair and configure.</li>

          <li>
            The device will begin collecting environmental data in real time.
          </li>

          <li>
            You can view insights and personalized recommendations via the app.
          </li>
        </ul>
      </>
    ),
  },
];

const HomeFaq = () => {
  return <FAQSection bgColor="white" faqData={HomeFaqData} />;
};

export { HomeFaqData };
export default HomeFaq;
